import { useEffect, useState } from "react";
import { Stage, Layer } from "react-konva";
import { Group, Line, Rect, Text, Circle } from 'react-konva';
import { handleStageWheel, cursorGrab, handleStageDragMoveHatazawa, handleStageDragStart, renderHybridPcs, renderPcsComn } from '../../../utils/DiagramParts';
import LoadImage from "../../../commons/LoadImage";
import { Col } from 'reactstrap';
import { getDeviceConfig } from "../../../api/api";
import Spinner from "../../../commons/Spinner";


const ComnHatazawa = (props) => {

  const [scene, setScene] = useState({ width: window.innerWidth, height: window.innerHeight - 150 });
  const [stageScale] = useState(0.44);
  const [isLoading, setIsLoading] = useState(true);
  const authToken = localStorage.getItem('accessToken');
  const [deviceList, setDeviceList] = useState({

    batArr: [
      { device_id: 'PCS 2-1', ip_address: '12.2.2.2', work_status: 0 },
      { device_id: 'PCS 2-2', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-3', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-4', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-5', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-6', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-7', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-8', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-9', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-10', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-11', ip_address: '', work_status: 0 },
      { device_id: 'PCS 2-12', ip_address: '', work_status: 0 },
    ],
    pcsArr: [
      { device_id: 'PCS 3-1', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-2', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-3', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-4', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-5', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-6', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-7', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-8', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-9', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-10', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-11', ip_address: '', work_status: 0 },
      { device_id: 'PCS 3-12', ip_address: '', work_status: 0 },
    ],
    hybridPcs: [{
      device_id: "PV_50KW_PCS_1", ip_address: '', work_status: 0
    }]

  });

  useEffect(() => {
    if (props.deviceId !== null) {
      const controller = new AbortController();
      const signal = controller.signal;
      const fetchDevices = async (signal) => {
        setIsLoading(true);
        const data = await getDeviceConfig(authToken, props.deviceId, { configType: 'network_config' }, signal);
        if (data.length > 0) {
          const hybridPcs = data.filter(el => el.device_id.toLowerCase().includes('50'));
          // const multiMeter = deviceList.filter(el => el.device_id.toLowerCase().includes('meter'));
          const batArr = data.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
          ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
          setScene({ width: window.innerWidth, height: window.innerHeight + batArr.length * 270 });

          const pcsArr = data.filter(el => el.device_id.toLowerCase().startsWith('pvpcs')
          ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

          setDeviceList({ batArr, pcsArr, hybridPcs });
        }
        setIsLoading(false);
      };

      fetchDevices(signal);
      return () => {
        controller.abort();
      };
    }//eslint-disable-next-line
  }, [props.deviceId]);

  return (<>{isLoading ? <Spinner /> :
    <Col style={{ 'height': "80vh" }}>
      <Stage
        id="hatazawa"
        width={scene.width}
        height={scene.height}
        scaleX={+stageScale}
        scaleY={+stageScale}
        onWheel={handleStageWheel}
        draggable={true}
        onDragStart={handleStageDragStart}
        onDragEnd={cursorGrab}
        onMouseOver={cursorGrab}
        onDragMove={handleStageDragMoveHatazawa}
        onClick={(e) => console.log(e.target)}
      >
        <Layer>
          {renderPcsComn([deviceList.batArr[0], deviceList.pcsArr[0], deviceList.batArr[1], deviceList.pcsArr[1]], 900, 245, 'iwaneright')}
          {renderPcsComn([deviceList.batArr[2], deviceList.pcsArr[2], deviceList.batArr[3], deviceList.pcsArr[3]], 900, 340, 'iwaneright')}
          {renderPcsComn([deviceList.batArr[4], deviceList.pcsArr[4], deviceList.batArr[5], deviceList.pcsArr[5]], 900, 535, 'iwaneright')}
          {renderPcsComn([deviceList.batArr[6], deviceList.pcsArr[6], deviceList.batArr[7], deviceList.pcsArr[7]], 900, 620, 'iwaneright')}
          {renderPcsComn([deviceList.batArr[8], deviceList.pcsArr[8], deviceList.batArr[9], deviceList.pcsArr[9]], 900, 700, 'iwaneright')}


          <Group x={1050} y={-25}>
            <Group x={0} y={340} >
              {renderHybridPcs(deviceList)}

              <Text x={200} y={-180} text={'5'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={200} y={-60} text={'6'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={200} y={30} text={'7'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Text x={370} y={105} text={'3'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={370} y={150} text={'8'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Text x={365} y={385} text={'PW'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={370} y={245} text={'1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={370} y={-95} text={'4'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={360} y={-45} text={'PW'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Line stroke="#548235" strokeWidth={5} x={370} y={340} points={[55, 60, 30, 60]} />
              <Text x={415} y={385} text={'TB`'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={370} y={18} text={'1'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={370} y={80} text={'2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
            </Group>

            <Group>
              {/* ----------------outer dashed line------------- */}
              <Line stroke="black" strokeWidth={1} points={[120, 120, 120, 805, 880, 805, 880, 120, 120, 120]} dash={[60, 15, 15, 18, 15, 18]} />
            </Group>
            <Group>

              {/* -----------Top----------------- */}
              <LoadImage src="/img/antena.png" x={615} y={20} height={133 / 3} width={132 / 3} />
              <Text x={655} y={25} text={'LTE'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />
              <Text x={120} y={80} text={'通信機器収納盤'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={625} y={85} text={'外部アンテナ'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Rect x={605} y={55} width={20} strokeWidth={1} height={30} stroke="black" />
              <Line stroke="#548235" strokeWidth={5} x={615} y={85} points={[1, 1, 1, 50]} />

              {/* --------------inner rectangle ----------------------------*/}
              <Rect x={540} y={135} width={150} strokeWidth={1} height={50} stroke="black" />
              <Text x={540} y={132} text={'        IOG-700 \n\n (モバイルルータ)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Rect x={690} y={240} width={175} strokeWidth={1} height={50} stroke="black" />
              <Text x={690} y={240} text={'SMA DATA MANAGER \n\n EDMM'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Rect x={550} y={350} width={170} strokeWidth={1} height={50} stroke="black" />
              <Text x={550} y={350} text={'OpenBlocks IoT VX2 \n\n (SEMS デバイス)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Rect x={522} y={420} width={170} strokeWidth={1} height={50} stroke="black" />
              <Text x={530} y={420} text={'MGate MB3280 \n\n (RS485/LAN変換器)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              <Rect x={642} y={620} width={170} strokeWidth={1} height={50} stroke="black" />
              <Text x={642} y={620} text={'MGate MB3280 \n\n (RS485/LAN変換器)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              {/* ----------------inner dashed horizontal line------------- */}
              <Line stroke="#548235" strokeWidth={5} x={360} y={200} points={[330, 60, 30, 60]} dash={[10, 10]} />
              <Line stroke="#548235" strokeWidth={5} x={370} y={315} points={[180, 60, 30, 60]} dash={[10, 10]} />
              <Line stroke="#548235" strokeWidth={5} x={370} y={380} points={[155, 60, 30, 60]} dash={[10, 10]} />

              <Line stroke="#548235" strokeWidth={5} x={370} y={400} points={[30, 60, 130, 60, 130, 162, 282, 162, 282, 220]} dash={[10, 10]} />

              {/* -----------------vertical line--------------------- */}
              <Line stroke="#548235" strokeWidth={5} x={370} y={445} points={[30, 60, 100, 60, 100, 152, 30, 152]} dash={[10, 10]} />
              <Line stroke="#548235" strokeWidth={5} x={568} y={162} points={[10, 20, 10, 100,]} dash={[14, 14]} />
              {/* <Circle x={575} y={215} radius={10} stroke="black" strokeWidth={1} dash={[20, 20]} rotation={190} /> */}
              {/* <Line stroke="black" strokeWidth={1} x={577} y={223} points={[1, 1, 1, 30,]} dash={[17, 17]} /> */}
              <Circle x={573} y={260} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
              <Line stroke="#548235" strokeWidth={5} x={577} y={268} points={[1, 1, 1, 83]} dash={[17, 17]} />

              {/* ------------------text inside dashed line-------------- */}
              <Text x={410} y={475} text={'LAN'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />
              <Text x={630} y={230} text={'LAN'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />
              <Text x={580} y={180} text={'LAN'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />
              <Text x={500} y={340} text={'LAN'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />
              <Text x={420} y={610} text={'LAN'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} />

              {/* ------------EDS first------------------ */}
              <Rect x={200} y={150} width={200} strokeWidth={1} height={380} stroke="black" />
              <Text x={300} y={400} text={'    EDS-208 No.1 \n\n (スイッチング HUB)\n\n        8ボ-ト'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} rotation={270} />

              {/* -------------EDS second------------- */}
              <Rect x={200} y={560} width={200} strokeWidth={1} height={230} stroke="black" />
              <Text x={300} y={750} text={'    EDS-208 No.2 \n\n (スイッチング HUB)\n\n        8ボ-ト'} fill="black" fontStyle="bold" fontSize={13} padding={10} lineHeight={0.75} rotation={270} />
              <Text x={200} y={565} text={'2'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={200} y={650} text={'3'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
              <Text x={200} y={730} text={'4'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

              {/* ---------------Lower part---------------------- */}
              <Group x={-10} y={70} >
                <Line stroke="#548235" strokeWidth={5} x={570} y={390} points={[10, 10, 10, 190,]} dash={[10, 10]} />
                <Circle x={575} y={490} radius={10} stroke="#548235" strokeWidth={5} dash={[20, 20]} rotation={190} />
                <Line stroke="#548235" strokeWidth={5} x={70} y={790} points={[505, 60, 30, 60]} dash={[10, 10]} />
                <Line stroke="#548235" strokeWidth={5} x={580} y={580} points={[1, 1, 1, 280]} dash={[10, 10]} />
                <Line stroke="#548235" strokeWidth={5} x={750} y={600} points={[1, 1, 1, 280]} dash={[10, 10]} />
                <Line stroke="#548235" strokeWidth={5} x={-330} y={815} points={[1080, 60, 30, 60]} dash={[10, 10]} />

                <Group x={-1050} y={10}>
                  <Rect x={900} y={800} width={250} strokeWidth={2} height={50} stroke="black" fill={"#d9e6ff"} />
                  <Text x={910} y={800} text={'XM2-110-995-M00-111\n\n (主幹用マルチメーター)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                  <Rect x={660} y={830} width={150} strokeWidth={2} height={50} stroke="black" fill={"#d9e6ff"} />
                  <Text x={700} y={830} text={'TD-BOX\n\n(SC-TD-X)'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                  <Line stroke="#548235" strokeWidth={5} x={330} y={810} points={[330, 60, 30, 60]} dash={[10, 10]} />
                  <Rect x={365} y={820} width={100} strokeWidth={2} height={30} stroke="black" fill={"#d9e6ff"} />
                  <Text x={380} y={820} text={'日射計'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                  <Text x={500} y={810} text={'専用 ケーブル'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                  <Rect x={367} y={860} width={100} strokeWidth={2} height={30} stroke="black" fill={"#d9e6ff"} />
                  <Text x={380} y={860} text={'気温計'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                  <Text x={500} y={870} text={'専用 ケーブル'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />

                  <Line stroke="#548235" strokeWidth={5} x={425} y={780} points={[230, 60, 30, 60]} dash={[10, 10]} />
                  <Text x={1180} y={790} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                  <Text x={820} y={828} text={'RS485'} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                  <Line stroke="#548235" strokeWidth={5} x={750} y={770} points={[1, 1, 1, 60]} />
                  <Text x={720} y={745} text={'AC 100V'} fill="#548235 " fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
                </Group>


              </Group>

            </Group>

          </Group>
        </Layer>
      </Stage>
    </Col>
  }
  </>

  );

};

export default ComnHatazawa;
